import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { CookiesProvider } from 'react-cookie';
import './index.css'
import App from './App.jsx'
import { BrowserRouter } from 'react-router';

createRoot(document.getElementById('root')).render(
  <>
   <BrowserRouter>
     <CookiesProvider>
        <App />
     </CookiesProvider>
     </BrowserRouter>
  </>,
)
